import { cn } from "@/lib/utils";

interface ToolCardPricingProps {
  pricing: string;
}

const ToolCardPricing = ({ pricing }: ToolCardPricingProps) => {
  return (
    <span className={cn(
      "text-xs px-2.5 py-1 rounded-full font-medium shadow-sm transition-all duration-300",
      pricing === "Free" 
        ? "bg-green-50 text-green-700 border border-green-200"
        : "bg-purple-50 text-purple-700 border border-purple-200"
    )}>
      {pricing}
    </span>
  );
};

export default ToolCardPricing;